import BottomTabButton from "components/bottom-tabs/BottomTabButton";
import styles from "components/bottom-tabs/css/BottomTabs.module.css";
import CrossIcon from "components/icons/CrossIcon";
import ColorValue from "types/enums/ColorValue";

export const BOTTOM_TABS_HEIGHT = 92;

export default function BottomTabs() {
  return (
    <div className={styles.tabs} style={{ height: BOTTOM_TABS_HEIGHT }}>
      <BottomTabButton
        href="/button1"
        icon={<CrossIcon colorValue={ColorValue.Secondary} />}
      >
        Button 1
      </BottomTabButton>
      <BottomTabButton
        href="/button2"
        icon={<CrossIcon colorValue={ColorValue.Secondary} />}
      >
        Button 2
      </BottomTabButton>
      <BottomTabButton
        href="/button3"
        icon={<CrossIcon colorValue={ColorValue.Secondary} />}
      >
        Button 3
      </BottomTabButton>
    </div>
  );
}
